module.exports = __webpack_public_path__ + "static/media/projects.dc55a68a.png";